import { useState, useEffect, useCallback } from "react";
import axiosInstance from "services/httpInterceptor";
import { useAnalytics } from "context/AnalyticsContext";

const useAIReportData = (competitorId) => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { companyId } = useAnalytics();

  const fetchData = useCallback(async () => {
    if (!competitorId || competitorId === "all_competitors") {
      setReport(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      let response;

      // Since we have added a new market_overview option to the competitors selectors
      if (competitorId === "market_overview") {
        if (!companyId) {
          // companyId resolves asynchronously after auth — wait for it
          setLoading(true);
          return;
        }
        response = await axiosInstance.get("/v1/reports/market-overview", {
          params: { companyId: companyId }
        });
      } else {
        // AI report
        response = await axiosInstance.get("/v1/reports/overview", {
          params: { competitorId: competitorId }
        });
      }
      setReport(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [competitorId, companyId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { report, loading, error };
};

export default useAIReportData; 